module.exports = __webpack_public_path__ + "assets/img/right1.c080e488.png";